import api from "../utils/api"

interface Response{
    message: string,
    statusCode: number,
}

export interface AboutUs{
  id: number,
  title: string,
  description: string,
  imageUrl:string
  activeStatus: boolean,
  isDeleted: boolean
}

export interface History {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  activeStatus: boolean;
  isDeleted: boolean;
}

export interface SchoolMgt {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
  activeStatus: boolean;
  isDeleted: boolean;
}

interface AboutUsResponse extends Response{
  data: AboutUs[],
}

interface HistoryResponse extends Response {
  data: History[];
}
interface SchoolMgtResponse extends Response {
  data: SchoolMgt[];
}

export const getAllAboutUs = async() => {
    return (await api.get('/AboutUsPage/GetAllAboutUs'))?.data as AboutUsResponse
}

export const getAllHistory = async() => {
    return (await api.get('/AboutUsPage/GetAllHistory'))?.data as HistoryResponse
}

export const getAllManagement = async() => {
    return (await api.get('/AboutUsPage/GetAllSchoolMgt'))?.data as SchoolMgtResponse
}